<template>
  <div class="SignUp min-h-screen flex flex-col lg:flex-row-reverse">
    <!--//v SignUp form container  -->
    <transition name="auth-form" appear>
      <div
        class="SignUp-form p-4 flex-1 flex flex-col md:p-8 lg:px-20 lg:py-6 2xl:py-24 lg:max-h-screen lg:overflow-y-auto"
      >
        <h1 class="font-minion text-xl text-primary-400 lg:text-3xl">
          Create your account at
          <span class="block font-minion font-bold mt-0.5 lg:mt-2">Ask A Fundraiser</span>
        </h1>

        <!-- //v form -->
        <form class="mt-5 flex-1 flex flex-col" @submit.prevent="onSubmitForm">
          <div class="flex-1">
            <div class="flex flex-col md:flex-row md:gap-5">
              <div class="md:w-1/2">
                <LoginFormInput
                  input-label="First Name"
                  label-for="su-f-name-input"
                  input-type="text"
                  input-id="su-f-name-input"
                  input-placeholder="First Name"
                  v-model.trim="formData.firstNameVal"
                  @form-input-change="onSignUpFormInputChange"
                  :inputClasses="`${
                    v$.firstNameVal.$error
                      ? 'shakeX border-red-400 !outline-red-400 duration-300 !text-red-400 placeholder:!text-red-300'
                      : ''
                  }`"
                />
                <transition name="auth-form">
                  <p class="pl-2 mt-1 text-sm text-red-400" v-if="v$.firstNameVal.$error">
                    {{ v$.firstNameVal.$errors[0].$message }}
                  </p>
                </transition>
              </div>
              <div class="mt-4 md:mt-0 md:w-1/2">
                <LoginFormInput
                  input-label="Last Name"
                  label-for="su-l-name-input"
                  input-type="text"
                  input-id="su-l-name-input"
                  input-placeholder="Last Name"
                  v-model.trim="formData.lastNameVal"
                  @form-input-change="onSignUpFormInputChange"
                  :inputClasses="`${
                    v$.lastNameVal.$error
                      ? 'shakeX border-red-400 !outline-red-400 duration-300 !text-red-400 placeholder:!text-red-300'
                      : ''
                  }`"
                />
                <transition name="auth-form">
                  <p class="pl-2 mt-1 text-sm text-red-400" v-if="v$.lastNameVal.$error">
                    {{ v$.lastNameVal.$errors[0].$message }}
                  </p>
                </transition>
              </div>
            </div>

            <div class="mt-4">
              <LoginFormInput
                input-label="Email"
                label-for="su-email-input"
                input-type="text"
                input-id="su-email-input"
                input-placeholder="e.g. name@domain.com"
                v-model.trim="formData.emailVal"
                @form-input-change="onSignUpFormInputChange"
                :inputClasses="`${
                  v$.emailVal.$error || signUpStatus.signUpErrMsg.includes('Email')
                    ? 'shakeX border-red-400 !outline-red-400 duration-300 !text-red-400 placeholder:!text-red-300'
                    : ''
                }`"
              />
              <transition name="auth-form">
                <p
                  class="pl-2 mt-1 text-sm text-red-400"
                  v-if="v$.emailVal.$error || signUpStatus.signUpErrMsg.includes('Email')"
                >
                  {{ v$.emailVal.$error ? v$.emailVal.$errors[0].$message : signUpStatus.signUpErrMsg }}
                </p>
              </transition>
            </div>

            <div class="mt-4">
              <LoginFormInput
                input-label="Create A Password"
                label-for="su-password-input"
                input-type="password"
                :is-password="true"
                input-id="su-password-input"
                input-placeholder="Min. 8 Charachter"
                v-model.trim="formData.passwordVal"
                @form-input-change="onSignUpFormInputChange"
                :inputClasses="`${
                  v$.passwordVal.$error
                    ? 'shakeX border-red-400 !outline-red-400 duration-300 !text-red-400 placeholder:!text-red-300'
                    : ''
                }`"
              />
              <transition name="auth-form">
                <p class="pl-2 mt-1 text-sm text-red-400" v-if="v$.passwordVal.$error">
                  {{ v$.passwordVal.$errors[0].$message }}
                </p>
              </transition>
            </div>

            <div class="mt-4">
              <LoginFormInput
                input-label="Confirm Your Password"
                label-for="su-conf-password-input"
                input-type="password"
                :is-password="true"
                input-id="su-conf-password-input"
                input-placeholder="Rewrite your Password"
                v-model.trim="formData.passwordConfVal"
                @form-input-change="onSignUpFormInputChange"
                :inputClasses="`${
                  v$.passwordConfVal.$error
                    ? 'shakeX border-red-400 !outline-red-400 duration-300 !text-red-400 placeholder:!text-red-300'
                    : ''
                }`"
              />
              <transition name="auth-form">
                <p class="pl-2 mt-1 text-sm text-red-400" v-if="v$.passwordConfVal.$error">
                  {{ v$.passwordConfVal.$errors[0].$message }}
                </p>
              </transition>
            </div>
          </div>
          <!--//v Terms and services  -->
          <p class="font-minion text-placeholder text-[18px] mt-4 text-center">
            By clicking Create an Account you agree to the
            <span class="font-bold">Terms</span> and <span class="font-bold">Conditions</span>.
          </p>
          <transition name="auth-form">
            <p class="pl-2 mt-3 text-sm text-red-400 text-center" v-if="signUpStatus.isSignUpFailed">
              {{ signUpStatus.signUpErrMsg }}
            </p>
          </transition>

          <!--//v form submit button -->
          <button
            class="w-full bg-[#00423D] font-minion text-[20px] text-white py-3 rounded-[8px] mt-6 font-bold lg:py-4 flex items-center justify-center"
            type="submit"
            ref="submitBtn"
          >
            <transition name="button-switch" mode="out-in">
              <span v-if="!isSendingRequest">Create an Account</span>
              <div v-else class="max-h-6 overflow-hidden inline-flex items-center justify-center pt-3">
                <Vue3Lottie :animationData="buttonAnimation" :height="120" :width="120" />
              </div>
            </transition>
          </button>
        </form>
     

        <p class="text-center mt-7 text-placeholder text-lg font-semibold font-minion">
          Have an account?
          <router-link class="font-minion text-primary-400 font-medium" to="/login"> Sign in now</router-link>
        </p>
      </div>
    </transition>

    <AuthSlider />
  </div>
</template>
<script setup>
//v Vue Imports
import { ref, onMounted, reactive, computed } from "vue";

//v Pinia Store
import { useAuthStore } from "@/stores/auth";
const authStore = useAuthStore();

//v Vue Router
import { RouterLink, RouterView, useRouter } from "vue-router";
const router = useRouter();

//v Components
import AuthSlider from "@/components/AuthSlider.vue";
import LoginFormInput from "@/components/LoginFormInput.vue";
//v Assets
import ButtonAni from "@/assets/loading-button-simple.json";

//v Vue3Lottie Animation Library
import { Vue3Lottie } from "vue3-lottie";

//v Vuelidate validation Library
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, email, sameAs, minLength } from "@vuelidate/validators";

//v First of all
//v Check if user is logged in and navigate user to home
if (authStore.user) {
  router.push({ name: "getting-started-welcome" });
}

//v View State
const buttonAnimation = ref(ButtonAni);
const isSendingRequest = ref(false);
const formData = reactive({
  firstNameVal: "",
  lastNameVal: "",
  emailVal: "",
  passwordVal: "",
  passwordConfVal: "",
});
const signUpStatus = reactive({
  isSignUpFailed: false,
  signUpErrMsg: "",
});
//v DOM Refs
const submitBtn = ref(null);

//v From Validation Rules
const rules = computed(() => {
  return {
    firstNameVal: {
      required: helpers.withMessage("Field Is Required!", required),
    },
    lastNameVal: {
      required: helpers.withMessage("Field Is Required!", required),
    },
    emailVal: {
      email: helpers.withMessage("Invalid Email Address!", email),
      required: helpers.withMessage("Field Is Required!", required),
    },
    passwordVal: {
      minLengthPassword: helpers.withMessage("Password should be at least 8 characters long!", minLength(8)),
      required: helpers.withMessage("Field Is Required!", required),
    },
    passwordConfVal: {
      sameAs: helpers.withMessage("Password and Confirm Password must match!", sameAs(formData.passwordVal)),
      required: helpers.withMessage("Field Is Required!", required),
    },
  };
});
//v useVuelidate state
const v$ = useVuelidate(rules, formData);

//v On form input change handlers
function onSignUpFormInputChange(e) {
  signUpStatus.isSignUpFailed = false;
  signUpStatus.signUpErrMsg = "";
}

//v Sign up Submit Function
async function onSubmitForm(e) {
  //v validate inputs
  const validationResult = await v$.value.$validate();
  if (validationResult) {
    //v Form is Valid
    isSendingRequest.value = true;
    submitBtn.value.disabled = true;

    //v Run store login action
    authStore
      .signUp({
        firstName: formData.firstNameVal,
        lastName: formData.lastNameVal,
        email: formData.emailVal,
        password: formData.passwordVal,
        conformPassword: formData.passwordConfVal,
      })
      .then(() => {
        //v If login was successful navigate user to next step
        router.push({ name: "organization-info-s1" });
      })
      .catch((err) => {
        let msg = "";
        if (err.message == "Failed to fetch") {
          msg = "Something went wrong, please try again later!";
        } else {
          msg = err.message;
        }

        signUpStatus.isSignUpFailed = true;
        signUpStatus.signUpErrMsg = msg;
      });

    isSendingRequest.value = false;
    submitBtn.value.disabled = false;
  } else {
    //v Form is invalid
  }
}
</script>

<style scoped>
/* transition for auth forms; login, sign up, change password, forgot password, org-info */
.auth-form-enter-active,
.auth-form-leave-active {
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.auth-form-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.auth-form-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.button-switch-enter-active,
.button-switch-leave-active {
  transition: opacity 0.3s ease-in-out, transform 0.4s ease-in-out;
}

.button-switch-enter-from {
  opacity: 0;
  transform: translateX(-100px);
}

.button-switch-leave-to {
  opacity: 0;
  transform: translateX(100px);
}
</style>
